/* eslint-disable @typescript-eslint/no-explicit-any */
import Highcharts from "highcharts";

export default function fixNavigatorMouseMove(H: typeof Highcharts) {
  H.wrap(
    H.Navigator.prototype,
    "onMouseMove",
    function (
      this: Highcharts.Navigator,
      _proceed: {
        apply: (args: any[]) => void;
      },
      ...args: any[]
    ) {
      const navigator = this as any,
        chart = navigator.chart,
        navigatorSize = navigator.navigatorSize,
        range = navigator.range,
        dragOffset = navigator.dragOffset,
        inverted = chart.inverted;

      let e = args[0];
      let chartX,
        left = navigator.left;

      // In iOS, a mousemove event with e.pageX === 0 is fired when holding
      // the finger down in the center of the scrollbar. This should be
      // ignored.
      if (!e.touches || e.touches[0].pageX !== 0) {
        // #4696

        e = chart.pointer.normalize(e);
        chartX = e.chartX;

        // Swap some options for inverted chart
        if (inverted) {
          left = navigator.top;
          chartX = e.chartY;
        }

        // Drag left handle or top handle
        if (navigator.grabbedLeft) {
          navigator.hasDragged = true;
          navigator.render(0, 0, chartX - left, navigator.otherHandlePos);
          // Drag right handle or bottom handle
        } else if (navigator.grabbedRight) {
          navigator.hasDragged = true;
          navigator.render(0, 0, navigator.otherHandlePos, chartX - left);
          // Drag scrollbar or open area in navigator
        } else if (navigator.grabbedCenter) {
          navigator.hasDragged = true;
          if (chartX < dragOffset) {
            // outside left
            chartX = dragOffset;
            // outside right
          } else if (chartX > navigatorSize + dragOffset - range) {
            chartX = navigatorSize + dragOffset - range;
          }

          navigator.render(0, 0, chartX - dragOffset, chartX - dragOffset + range);
        }
        if (
          navigator.hasDragged &&
          navigator.scrollbarOptions && // HERE IS METROSCOPE FIX
          Highcharts.pick(
            navigator.scrollbarOptions.liveRedraw, // HERE IS METROSCOPE FIX

            // By default, don't run live redraw on VML, on touch
            // devices or if the chart is in boost.
            (H as any).svg && !(H as any).isTouchDevice && !(this.chart as any).isBoosting,
          )
        ) {
          e.DOMType = e.type; // DOMType is for IE8
          window.setTimeout((): void => {
            navigator.onMouseUp(e);
          }, 0);
        }
      }
    },
  );
}
